var React = require('react');

function UiArrowCircleRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ui-arrow-circle-right"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M23,46A23,23,0,1,0,0,23,23,23,0,0,0,23,46ZM12,22H31.59l-4.3-4.29a1,1,0,0,1,0-1.42,1,1,0,0,1,1.42,0l6,6a1,1,0,0,1,.21.33.94.94,0,0,1,0,.76,1,1,0,0,1-.21.33l-6,6a1,1,0,0,1-1.42-1.42L31.59,24H12a1,1,0,0,1,0-2Z","key":0}),React.createElement("path",{"d":"M12,24H31.59l-4.3,4.29a1,1,0,0,0,1.42,1.42l6-6a1,1,0,0,0,.21-.33.94.94,0,0,0,0-.76,1,1,0,0,0-.21-.33l-6-6a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.42L31.59,22H12a1,1,0,0,0,0,2Z","style":{"fill":"none"},"key":1})])]);
}

UiArrowCircleRight.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 46 46"};

module.exports = UiArrowCircleRight;

UiArrowCircleRight.default = UiArrowCircleRight;
